import { render, staticRenderFns } from "./Divcard.vue?vue&type=template&id=a4c8aeb0&scoped=true&"
import script from "./Divcard.vue?vue&type=script&lang=js&"
export * from "./Divcard.vue?vue&type=script&lang=js&"
import style0 from "./Divcard.vue?vue&type=style&index=0&id=a4c8aeb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c8aeb0",
  null
  
)

export default component.exports